__turbopack_context__.v({
  "adminAvatar": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__adminAvatar",
  "directorAvatar": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__directorAvatar",
  "dropdown": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__dropdown",
  "homeBenefitsSectionRoleDropdownItem": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__homeBenefitsSectionRoleDropdownItem",
  "img2": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__img2",
  "img3": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__img3",
  "img4": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__img4",
  "input": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__input",
  "name": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__name",
  "officerAvatar": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__officerAvatar",
  "popoverCore": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__popoverCore",
  "rightIcon": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__rightIcon",
  "role2": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__role2",
  "roleDropdown": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__roleDropdown",
  "svg__bHqhZ": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__svg__bHqhZ",
  "svg__fiA3J": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__svg__fiA3J",
  "svg__wgr2E": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__svg__wgr2E",
  "text10": "PlasmicHomeBenefitsSectionRoleDropdown-module___-eYKW__text10",
});
